module.exports = __webpack_public_path__ + "media/images/shared/ad/j_rock_bar-b593db83ce08d7e23e742aa79eb230e6.jpg";